var map = {
	"./1.jpeg": 5367,
	"./2.jpeg": 3658,
	"./3.jpeg": 6609,
	"./4.jpeg": 9012,
	"./5.jpeg": 1755,
	"./6.jpeg": 446,
	"./7.jpeg": 6005,
	"./IMG_9265.jpg": 581,
	"./IMG_9279.jpg": 5254,
	"./IMG_9282.jpg": 1472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5929;